import {GetConfigFunc} from '../types';
import {createMockDataSyncService, createPusherService} from './services';
import {IEntityResponseService} from './types';

export const createEntityDataSyncService = <
  TData extends Record<TIdKey, any>,
  TEntityName extends string = any,
  TIdKey extends keyof TData = keyof TData
>(
  getConfig: GetConfigFunc,
): IEntityResponseService<TData, TEntityName, TIdKey> => {
  if (getConfig().Api.Mode === 'mock') {
    // Create mock pusher service
    return createMockDataSyncService<TData>();
  } else {
    // Create REAL pusher service
    return createPusherService<TData>(getConfig);
  }
};
